import { InjectionToken } from '@angular/core';
import { AbstractFeatureFlags } from '@fmnts/common/feature-flags';
import { Customer } from '@formunauts/shared/domain';

export const SharedCustomerUiFeatureFlagsToken = new InjectionToken<
  AbstractFeatureFlags<Customer.Features>
>('@formunauts.shared.customer.ui.feature-flags');
